/**
 * Validates an email address
 *
 * @param {String} value - The email to be validated
 *
 * @returns {Boolean} - The validity of the email
 */
const email =
  (msg = 'Invalid e-mail.') =>
  (value: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || msg;

export default email;
